import { render, staticRenderFns } from "./PendingModal.vue?vue&type=template&id=44bc8d3f&scoped=true&"
import script from "./PendingModal.vue?vue&type=script&lang=js&"
export * from "./PendingModal.vue?vue&type=script&lang=js&"
import style0 from "./PendingModal.vue?vue&type=style&index=0&id=44bc8d3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bc8d3f",
  null
  
)

export default component.exports